import apiClient from '../http/apiClient';

export default class DiscountConditionApiService {
    static create = (condition) => apiClient.post('/discount-condition', condition);

    static find = (box = null, patientType = null, country = null) =>
        apiClient.get('/discount-condition/find', {params: {box, patientType, country}});

    static list = (customer) => apiClient.get('/discount-condition', {params: {customer}});
}
